export const EVENTS_INITIAL_FORM = {
  title: "",
  subtitle: "",
  categorie: "",
  description: "",
  start_date: "",
  end_date: "",
  photo_vignette: "",
  external_link: "",
  all_day: false,
  is_active: true,
};

export const EVENTS_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Tous",
    description: "Afficher tous les événements.",
  },
  {
    value: "active",
    label: "Publiés",
    description: "Visibles sur le site public.",
  },
  {
    value: "inactive",
    label: "Brouillons",
    description: "Masqués du site public.",
  },
];

export const EVENTS_LIMIT_OPTIONS = [12, 24, 48, 96];

export const EVENT_CATEGORY_SUGGESTIONS = [
  "Culture",
  "Sport",
  "Conseil municipal",
  "Vie associative",
  "Jeunesse",
  "Solidarité",
  "Travaux",
  "Cérémonie",
];

export const EVENTS_FORM_HELPERS = [
  "Cochez l’option journée entière si aucun horaire précis n’est nécessaire.",
  "La date de fin est utile pour les événements sur plusieurs jours.",
  "Un visuel rend l’événement plus attractif sur le site public.",
];

export const EVENTS_MEDIA_CATEGORY_DEFAULT = "events";